import { createContext, useState } from 'react';
import { RootLoadingSpinner } from '../components/RootLoadingSpinner';

interface ILoadingSpinnerContext {
  setRootLoadingSpinnerStatus: (isLoading: boolean) => void;
}

export const LoadingSpinnerContext = createContext<ILoadingSpinnerContext>({
  setRootLoadingSpinnerStatus: null,
});

export const LoadingSpinnerProvider = ({ children }) => {
  const [isLoading, setRootLoadingSpinnerStatus] = useState<boolean>(false);
  return (
    <LoadingSpinnerContext.Provider value={{ setRootLoadingSpinnerStatus }}>
      {isLoading && <RootLoadingSpinner />}
      <>{children}</>
    </LoadingSpinnerContext.Provider>
  );
};
